class SectionsHelper {
  static findSectionIDWithPage(sections, pageID) {
    let sectionID = undefined;

    sections.map((section) => {
      section.get('spreads').map((spread, spreadIndex) => {
        if (
          spread
            .get('pages')
            .toJS()
            .some((page) => {
              return page.pageID === pageID;
            })
        ) {
          sectionID = section.get('sectionID');
        }
      });
    });

    return sectionID;
  }
}

export default SectionsHelper;
